export default {
  ALIGNER_CHANGE: 'ALIGNER_CHANGE',
  MISSED_ALIGNER_CHANGED_DATE: 'MISSED_ALIGNER_CHANGED_DATE',
  MESSAGE_SENT_TO_DOCTOR: 'MESSAGE_SENT_TO_DOCTOR',
  NEW_MESSAGE: 'NEW_MESSAGE',
  ALIGNER_CHANGE_FEEDBACK_ADDED: 'ALIGNER_CHANGE_FEEDBACK_ADDED',
  TREATMENT_STARTING: 'TREATMENT_STARTING',
  PATIENT_CONNECTED_WITH_DOCTOR: 'PATIENT_CONNECTED_WITH_DOCTOR',
  ALIGNER_PRODUCTION_ORDER_REMINDER: 'ALIGNER_PRODUCTION_ORDER_REMINDER',
  UPGRADE_PATIENT_TO_MOBILE_APP: 'UPGRADE_PATIENT_TO_MOBILE_APP',
  RESUME_TREATMENT_REMINDER: 'RESUME_TREATMENT_REMINDER',
  CREATE_REFINEMENT_REMINDER: 'CREATE_REFINEMENT_REMINDER',
  MANUAL_ALIGNER_CHANGE: 'MANUAL_ALIGNER_CHANGE',
  ALIGNER_CHECK_IN_FOR_DOCTOR: 'ALIGNER_CHECK_IN_FOR_DOCTOR',
  ISSUE_REPORTED: 'ISSUE_REPORTED',
  APPOINTMENT_REMINDER: 'APPOINTMENT_REMINDER',
  PAYMENT_REMINDER: 'PAYMENT_REMINDER',
  CALENDAR_REMINDER: 'CALENDAR_REMINDER',

  PRACTICE_CONNECTED_ORG: 'PRACTICE_CONNECTED_ORG',
  PATIENT_ASSIGNED_TO_PRACTICE: 'PATIENT_ASSIGNED_TO_PRACTICE',
  PATIENT_ADDED_BY_PRACTICE: 'PATIENT_ADDED_BY_PRACTICE',

  NEW_ORDER_ADDED: 'NEW_ORDER_ADDED',
  ORG_SEND_TREATMENT_PLAN_FOR_APPROVAL: 'ORG_SEND_TREATMENT_PLAN_FOR_APPROVAL',
  PLAN_FINALIZED_BY_PRACTICE: 'PLAN_FINALIZED_BY_PRACTICE',
  ORDER_ON_HOLD: 'ORDER_ON_HOLD',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  RE_PLAN_TREATMENT: 'RE_PLAN_TREATMENT',

  LAB_ADMIN_ASSIGN_ORDER: 'LAB_ADMIN_ASSIGN_ORDER',
  THIRD_PARTY_CUSTOMER_REQUEST_STL_FILES: 'THIRD_PARTY_CUSTOMER_REQUEST_STL_FILES',
  THIRD_PARTY_CUSTOMER_REQUEST_RE_PLAN: 'THIRD_PARTY_CUSTOMER_REQUEST_RE_PLAN',
  THIRD_PARTY_CUSTOMER_SEND_CASE: 'THIRD_PARTY_CUSTOMER_SEND_CASE',
  THIRD_PARTY_CUSTOMER_APPROVE_TREATMENT_PLAN: 'THIRD_PARTY_CUSTOMER_APPROVE_TREATMENT_PLAN',
  LAB_ADMIN_SEND_TREATMENT_PLAN: 'LAB_ADMIN_SEND_TREATMENT_PLAN',
  LAB_ADMIN_SEND_STL_FILES: 'LAB_ADMIN_SEND_STL_FILES',
  TREATMENT_COMPLETED: 'TREATMENT_COMPLETED',
  COMMENT_ADDED_ON_ORDER: 'COMMENT_ADDED_ON_ORDER',
  INVITATION_REJECTED: 'INVITATION_REJECTED',
  DOCTOR_INVITATION_RECEIVED: 'DOCTOR_INVITATION_RECEIVED',
  STL_FILE_APPROVED: 'STL_FILE_APPROVED',
  DOCTOR_INVITATION_REJECTED: 'DOCTOR_INVITATION_REJECTED',
  TREATMENT_STARTING_TOMORROW: 'TREATMENT_STARTING_TOMORROW',

  MANUFACTURING_IN_TRANSIT: 'MANUFACTURING_IN_TRANSIT',
  MANUFACTURING_DELIVERED: 'MANUFACTURING_DELIVERED',
  CASE_MOVED_TO_PLANNING: 'CASE_MOVED_TO_PLANNING',
  CASE_MOVED_TO_PRODUCTION: 'CASE_MOVED_TO_PRODUCTION',
  MANUFACTURING_COMPLETED: 'MANUFACTURING_COMPLETED',
  CASE_READY_TO_BEGIN_TREATMENT: 'CASE_READY_TO_BEGIN_TREATMENT',
  CASE_ASSIGNED_TO_YOU: 'CASE_ASSIGNED_TO_YOU',
  NEW_COMMENT_ADDED: 'NEW_COMMENT_ADDED',
  STATUS_UPDATED: 'STATUS_UPDATED',
  RECORDS_ADDED: 'RECORDS_ADDED',
  PRESCRIPTION_ADDED: 'PRESCRIPTION_ADDED',
  PLANNING_CASE_COMPLETED: 'PLANNING_CASE_COMPLETED',

  TREATMENT_PLAN_ADDED: 'TREATMENT_PLAN_ADDED',

  NEED_MORE_INFO_REQUESTED: 'NEED_MORE_INFO_REQUESTED',
  UPDATED_FROM_NEED_MORE_INFO_TO_ORDERED: 'UPDATED_FROM_NEED_MORE_INFO_TO_ORDERED',

  PLANNING_CUSTOMER_PATIENT_ONBOARDED: 'PLANNING_CUSTOMER_PATIENT_ONBOARDED',
  PLANNING_CUSTOMER_LAB_UPLOADED_STL_FILES: 'PLANNING_CUSTOMER_LAB_UPLOADED_STL_FILES',
  PLANNING_CUSTOMER_CASE_COMPLETED: 'PLANNING_CUSTOMER_CASE_COMPLETED',
  PLANNING_CUSTOMER_TREATMENT_PLAN_APPROVED: 'PLANNING_CUSTOMER_TREATMENT_PLAN_APPROVED',
  PLANNING_CUSTOMER_TREATMENT_PLAN_REVISION: 'PLANNING_CUSTOMER_TREATMENT_PLAN_REVISION',
  PLANNING_CUSTOMER_TREATMENT_PLAN_SENT_FOR_APPROVAL:
    'PLANNING_CUSTOMER_TREATMENT_PLAN_SENT_FOR_APPROVAL',
  PLANNING_CUSTOMER_NEED_MORE_INFO_REQUESTED: 'PLANNING_CUSTOMER_NEED_MORE_INFO_REQUESTED',

  VSP_CASE_ASSIGNED: 'VSP_CASE_ASSIGNED',
  VSP_CASE_SUBMITTED: 'VSP_CASE_SUBMITTED',
  VSP_FILES_UPLOADED: 'VSP_FILES_UPLOADED',
  VSP_PLAN_READY_FOR_REVIEW: 'VSP_PLAN_READY_FOR_REVIEW',
  VSP_PLAN_APPROVED: 'VSP_PLAN_APPROVED',
  VSP_REVISION_REQUESTED: 'VSP_REVISION_REQUESTED',
  VSP_MORE_INFORMATION_REQUIRED: 'VSP_MORE_INFORMATION_REQUIRED',
  VSP_PLANNING_COMPLETED: 'VSP_PLANNING_COMPLETED',
  VSP_PRODUCTION_ORDER_CREATED: 'VSP_PRODUCTION_ORDER_CREATED',
  VSP_ORDER_SHIPPED: 'VSP_ORDER_SHIPPED',
  VSP_ORDER_DELIVERED: 'VSP_ORDER_DELIVERED',
  VSP_NEW_MESSAGE_LAB_TO_CUSTOMER: 'VSP_NEW_MESSAGE_LAB_TO_CUSTOMER',
  VSP_NEW_MESSAGE_CUSTOMER_TO_LAB: 'VSP_NEW_MESSAGE_CUSTOMER_TO_LAB',
} as const
